import { toBN } from 'web3-utils'

export function getClassId(tokenId: string): string {
    return toBN(tokenId).toString(10)
}
